export const getBusinessErrorMessage = (error, fallbackMessage) => {
    const detail = error?.error;
    // La API reserva 4001 para OhlVirtualCenterException (errores controlados).
    if ((detail?.code === 4001 || detail?.code === '4001') &&
        typeof detail.message === 'string' && detail.message.trim()) {
        return detail.message.trim();
    }

    return fallbackMessage;
};
